
let footerItems:HTMLCollectionOf<Element>;

export function initFooter() {
  footerItems = document.getElementsByClassName('footer-item');

  console.log('footerItems:', footerItems);
}